export default {
  RequiredIndicator__REQUIRED_INDICATOR_LABEL: "Required fields",
};
